import React, { useState, useContext } from 'react';
import Amplify, { Auth } from 'aws-amplify';
// import { Hub, Logger } from 'aws-amplify';

// refer to this document for more config options.
// https://docs.amplify.aws/lib/auth/start/q/platform/js#re-use-existing-authentication-resource
Amplify.configure({
  Auth: {
    userPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID,
    region: process.env.REACT_APP_AWS_DEFAULT_REGION,
  },
});

export const AuthContext = React.createContext(null);

export default function useAuth() {
  const login = async (username, password) =>
    await Auth.signIn(username, password);

  const logout = async () => await Auth.signOut();

  const signUp = async (username, password, clinic) =>
    await Auth.signUp({
      username,
      password,
      attributes: {
        clinic,
      },
    });

  const getCurrentUser = async () =>
    await Auth.currentAuthenticatedUser({ bypassCache: true });

  const completeNewPassword = async (userObject, newPassword) => {
    // const { requiredAttributes } = userObject.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
    return await Auth.completeNewPassword(
      userObject, // the Cognito User Object
      newPassword // the new password
      // // OPTIONAL, the required attributes
      // {
      //   email: 'xxxx@example.com',
      //   phone_number: '1234567890',
      // }
    );
  };

  const resetPassword = async (username, code, newPassword) => {
    return await Auth.forgotPasswordSubmit(username, code, newPassword);
    // const user = await Auth.currentAuthenticatedUser();
    // return await Auth.changePassword(user, oldPassword, newPassword);
  };

  const forgotPassword = async (username) => {
    return await Auth.forgotPassword(username);
  };

  return {
    login,
    logout,
    signUp,
    getCurrentUser,
    completeNewPassword,
    resetPassword,
    forgotPassword,
  };
}

export const useAuthContext = () => useContext(AuthContext);

// const logger = new Logger('My-Logger');

// const listener = (data) => {
//   switch (data.payload.event) {
//     case 'signIn':
//       logger.info('user signed in');
//       break;
//     case 'signUp':
//       logger.info('user signed up');
//       break;
//     case 'signOut':
//       logger.info('user signed out');
//       break;
//     case 'signIn_failure':
//       logger.error('user sign in failed');
//       break;
//     case 'tokenRefresh':
//       logger.info('token refresh succeeded');
//       break;
//     case 'tokenRefresh_failure':
//       logger.error('token refresh failed');
//       break;
//     case 'configured':
//       logger.info('the Auth module is configured');
//       break;
//     default:
//       logger.info('default: ', data.payload);
//   }
// };

// Hub.listen('auth', listener);
